import {
    GET_MEMBERSHIPPACKAGES_INFO_LOADING, MEMBERSHIPPACKAGES_DATA_SUCCESS,
    MEMBERSHIPPACKAGES_DATA_ERROR
} from "../actions/actionMembershipPackages";
import { apiMembershipPackages } from 'api';
import { put, takeEvery } from 'redux-saga/effects';

async function fetchAsync(func, displayAreaNo) {
    const response = await func(displayAreaNo);

    if (response.ok && response.status == 200) {
        return await response.json();
    }
    else if (response.status == 204) {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"No membership packages record found, response status: " + response.status + "\"}]}")
    }
    if (response.status == 400) {
        let error = await response.json();
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
    }
    if (response.status == 401) {
        let error = await response.json();
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Message + " response status: " + response.status + "\"}]}")
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get membership packages, response status: " + response.status + "\"}]}")
    }
}

function* fetchMembershipPackagesData(action) {
    try {
        const data = yield fetchAsync(apiMembershipPackages, action.payload.DisplayAreaNo)
        yield put({ type: MEMBERSHIPPACKAGES_DATA_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: MEMBERSHIPPACKAGES_DATA_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

export const sagaMembershipPackages = [
    takeEvery(GET_MEMBERSHIPPACKAGES_INFO_LOADING, fetchMembershipPackagesData)
];
